import { useRef } from 'react'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons'

import { Box, Link, Text } from '@domain-group/suit-theme'
import { useDraggable } from '@domain-group/react-hooks'

import { getGridSize } from '@functions/orderItem'

import { useRelations as useOrderItemRelations } from '@hooks/useOrderItem'

import type { OrderItemModel } from '@models/types'

import styles from './styles.module.scss'

interface OrderItemProps {
  detailMode?: boolean,
  dragDisabled?: boolean,
  orderItem: OrderItemModel,
}

const OrderItem = (props: OrderItemProps) => {
  const {
    detailMode,
    dragDisabled = false,
    orderItem,
  } = props

  const relations = useOrderItemRelations(orderItem)
  const {
    agency,
    campaign,
    serviceProduct,
  } = relations

  // @ts-expect-error TS2740
  const gridSize = getGridSize({ serviceProduct })

  const draggableRef = useRef(null)

  useDraggable(draggableRef, {
    createElementClone: true,
    disabled: false,
    documentElementId: 'main-stage',
    draggableZIndex: 99999,
    draggingClassName: styles.dragging,
  })

  return (
    <Box
      border="1px solid"
      borderColor="lineColor"
      borderRadius={5}
      className={classnames(styles.root, dragDisabled ? styles.disabled : 'draggable')}
      // @ts-expect-error TS2339
      data-columns={gridSize.columns}
      data-item-type="orderItem"
      data-order-id={orderItem.order_id}
      data-order-item-id={orderItem.id}
      // @ts-expect-error TS2339
      data-rows={gridSize.rows}
      flexShrink="0"
      opacity={dragDisabled ? 0.5 : 1}
      overflow="hidden"
      paddingY="medium"
      paddingLeft="large"
      position="relative"
      ref={draggableRef}
    >
      <Box
        backgroundColor="green"
        bottom="0"
        height="100%"
        left="0"
        position="absolute"
        top="0"
        width="6px"
      />

      <Box alignItems="flex-start" flexDirection="column" fontSize="xsmall" style={{ gap: '4px', userSelect: 'none' }}>
        <Text color="bodyFontColor" fontWeight="bold">
          {detailMode ? campaign.suburb_name : campaign.address}
        </Text>

        {detailMode && (
          <>
            <Text color="bodyFontColor">
              {campaign.address}
            </Text>

            <Text color="bodyFontLightColor">
              {agency.title}
            </Text>
          </>
        )}

        <Link
          href="#"
          textProps={{
            color: 'bodyFontLightColor',
          }}
        >
          {serviceProduct.title}
        </Link>
      </Box>

      <Box
        as="span"
        className={styles.dragHandle}
        position="absolute"
        right="8px"
        top="calc(50% - 8px)"
        width="auto"
      >
        <FontAwesomeIcon icon={faGripDotsVertical} />
      </Box>
    </Box>
  )
}

export default OrderItem
